import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
  MappedDealerOrderItem,
  useGetDealerOrderHistory,
} from "../../queries/useGetDealerOrderHistory";
import {
  DEALER_DATE_TIME,
  DateDisplay,
} from "../../ui/DateDisplay/DateDisplay";
import { Placeholder } from "../../ui/Placeholder";
import { PriceDisplay } from "../../ui/PriceDisplay/PriceDisplay";
import { TableHeader } from "../ColumnSort/TableHeader";
import { NoData } from "../NoData/NoData";

const placehoders: MappedDealerOrderItem[] = [];

for (let i = 0; i < 3; i++) {
  placehoders.push({} as MappedDealerOrderItem);
}

export const DealerOrdersTable: FunctionComponent = () => {
  const { data = placehoders, isLoading } = useGetDealerOrderHistory();
  const { t } = useTranslation();
  return (
    <>
      <table className="border-collapse table-auto w-full text-xs">
        <thead>
          <tr className="border-b-2 border-edge">
            <TableHeader
              className="text-left"
              field="type"
              tableName="orderReport"
            />
            <TableHeader
              className="text-right"
              field="orderNumber"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="createdBy"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="customerName"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="customerEmail"
              tableName="orderReport"
            />
            <TableHeader
              className="text-right"
              field="customerPhone"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="dateCreated"
              tableName="orderReport"
            />
            <TableHeader
              className="text-right"
              field="orderTotal"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="customerNotes"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="poNumber"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="confirmationNumber"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="deliveryStatus"
              tableName="orderReport"
            />
            <TableHeader
              className="text-left"
              field="viewOrders"
              tableName="orderReport"
            />
          </tr>
        </thead>
        <tbody>
          {data.map(
            (
              {
                confirmationNumber,
                createdBy,
                customerEmail,
                customerName,
                customerNotes,
                customerPhone,
                dateCreated,
                deliveryStatus,
                orderNumber,
                orderTotal,
                poNumber,
                type,
                viewOrders,
              },
              key
            ) => (
              <tr
                className="border-b border-edge align-top"
                key={`${orderNumber}-${key}`}
              >
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{type}</Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>
                    <a
                      className="underline text-primary"
                      href={viewOrders}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {orderNumber}
                    </a>
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{createdBy}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerName}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerEmail}</Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>{customerPhone}</Placeholder>
                </td>
                <td className="px-2 py-1 min-w-[8em]">
                  <Placeholder loading={isLoading}>
                    <DateDisplay format={DEALER_DATE_TIME}>
                      {dateCreated}
                    </DateDisplay>
                  </Placeholder>
                </td>
                <td className="px-2 py-1 text-right">
                  <Placeholder loading={isLoading}>
                    <PriceDisplay>{orderTotal}</PriceDisplay>
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{customerNotes}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>{poNumber}</Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>
                    {confirmationNumber}
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>
                    {deliveryStatus}
                  </Placeholder>
                </td>
                <td className="px-2 py-1">
                  <Placeholder loading={isLoading}>
                    {viewOrders && (
                      <a
                        className="underline text-primary"
                        href={viewOrders}
                        rel="noreferrer"
                        target="_blank"
                      >
                        {t("quoteReport.details")}
                      </a>
                    )}
                  </Placeholder>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
      {data.length === 0 && (
        <NoData className="max-w-[12em] mx-auto my-8">
          {t("quoteReport.noData")}
        </NoData>
      )}
    </>
  );
};
